import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SidebarProvider } from './context/SidebarContext';
import Layout from './components/Layout';
import SidebarCliente    from './components/SidebarCliente';
import SidebarAllenatore from './components/SidebarAllenatore';

import Login              from './pages/Login';
import Register           from './pages/Register';
import VerifyEmail        from './pages/VerifyEmail';
import SetPassword        from './pages/SetPassword';
import PasswordDimenticata from './pages/PasswordDimenticata';
import ReimpostaPassword  from './pages/ReimpostaPassword';
import Privacy            from './pages/Privacy';
import Dashboard          from './pages/Dashboard';
import ProductsCatalog    from './pages/products/Catalog';
import Categories         from './pages/products/Categories';
import Warehouse          from './pages/products/Warehouse';
import Variants           from './pages/products/Variants';
import Orders             from './pages/orders/Orders';
import NewOrder           from './pages/orders/NewOrder';
import Customers          from './pages/customers/Customers';
import CustomerGroups     from './pages/customers/Groups';
import Suppliers          from './pages/suppliers/Suppliers';
import PurchaseOrders     from './pages/suppliers/PurchaseOrders';
import MovimentiBancari   from './pages/cash/MovimentiBancari';
import ResocontoSpese     from './pages/cash/ResocontoSpese';
import SpeseRicorrenti    from './pages/cash/SpeseRicorrenti';
import Settings           from './pages/settings/Settings';
import Widgets            from './pages/settings/Widgets';
import Changelog          from './pages/changelog/Changelog';
import Dipendenti         from './pages/dipendenti/Dipendenti';
import SchedaDipendente   from './pages/dipendenti/SchedaDipendente';
import CalendarioPresenze from './pages/dipendenti/CalendarioPresenze';
import RiepilogoMensile   from './pages/dipendenti/RiepilogoMensile';
import PagheMensili       from './pages/dipendenti/PagheMensili';
import ListinoAttivita    from './pages/dipendenti/ListinoAttivita';
import GestioneTemplate   from './pages/dipendenti/GestioneTemplate';
import ContrattiDipendenti from './pages/dipendenti/ContrattiDipendenti';
import AnagraficaAllenatore from './pages/allenatore/AnagraficaAllenatore';
import DashboardCliente   from './pages/cliente/DashboardCliente';
import CatalogoSolaLettura from './pages/cliente/CatalogoSolaLettura';
import CatalogoCliente    from './pages/cliente/CatalogoCliente';
import OrdiniCliente      from './pages/cliente/OrdiniCliente';
import TicketsCliente     from './pages/cliente/TicketsCliente';
import RichiestaSocioPage from './pages/cliente/RichiestaSocioPage';
import CampiCliente       from './pages/cliente/CampiCliente';
import LaMiaTessera       from './pages/cliente/LaMiaTessera';
import LeMieRicevute      from './pages/cliente/LeMieRicevute';
import IlMioProfilo       from './pages/cliente/IlMioProfilo';
import Campi               from './pages/campi/Campi';
import PortaleAllenatore  from './pages/allenatore/PortaleAllenatore';
import CalendarioAllenatori from './pages/allenatore/CalendarioAllenatori';
import ContrattiAllenatore from './pages/allenatore/ContrattiAllenatore';
import DocumentiAllenatore from './pages/allenatore/DocumentiAllenatore';
import Rimborsi           from './pages/rimborsi/Rimborsi';
import RimborsiAllenatore from './pages/rimborsi/RimborsiAllenatore';
import Segreteria         from './pages/segreteria/Segreteria';
import Tesseramenti       from './pages/Tesseramenti';
import Anagrafica         from './pages/anagrafica/Anagrafica';
import FormLista          from './pages/form/FormLista';
import FormEditor         from './pages/form/FormEditor';
import ContrattiStrutture from './pages/strutture/ContrattiStrutture';
import Organizzazione from './pages/organizzazione/Organizzazione';
import BusinessPlan from './pages/businessplan/BusinessPlan';
import VocePortale from './components/VocePortale';
import SupportoStaff from './pages/supporto/SupportoStaff';
import Fipav from './pages/fipav/Fipav';
import Aibvc from './pages/aibvc/Aibvc';
import MioAibvc from './pages/aibvc/MioAibvc';
import ContabilitaTornei from './pages/tornei/ContabilitaTornei';
import PortaleShell from './components/PortaleShell';
import FormPubblico       from './pages/FormPubblico';
import CalendarioPubblico from './pages/CalendarioPubblico';
import GuidaAllenatore    from './pages/guide/GuidaAllenatore';
import GuidaCliente       from './pages/guide/GuidaCliente';
import PlanningCorsi      from './pages/planning/PlanningCorsi';
import Corsisti           from './pages/planning/Corsisti';
import RicevuteAsd        from './pages/ricevuteAsd/RicevuteAsd';
import CalendarioAttivita from './pages/calendario/CalendarioAttivita';
import Guida              from './pages/Guida';
import PasswordManager    from './pages/passwordmanager/PasswordManager';
import Centri             from './pages/centri/Centri';
import CambiaPasswordObbligatoria from './pages/CambiaPasswordObbligatoria';
import { puoFare } from './utils/permessi';
import InformativaCollaboratori from './pages/InformativaCollaboratori';
import AggiornamentoPrivacy from './pages/AggiornamentoPrivacy';
import CambiaPassword     from './pages/CambiaPassword';

import './index.css';

const LayoutCliente = ({ children }) => <PortaleShell Sidebar={SidebarCliente}>{children}</PortaleShell>;

const LayoutAllenatore = ({ children }) => <PortaleShell Sidebar={SidebarAllenatore}>{children}</PortaleShell>;

// Wrapper che inietta ThemeProvider con userId corretto
const AppWithTheme = () => {
  const { user } = useAuth();
  return (
    <ThemeProvider userId={user?.id}>
    <SidebarProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login"        element={<Login/>}/>
          <Route path="/register"     element={<Register/>}/>
          <Route path="/verify-email" element={<VerifyEmail/>}/>
          <Route path="/set-password" element={<SetPassword/>}/>
          <Route path="/password-dimenticata" element={<PasswordDimenticata/>}/>
          <Route path="/reimposta-password" element={<ReimpostaPassword/>}/>
          <Route path="/privacy"      element={<Privacy/>}/>
          <Route path="/f/:slug"      element={<FormPubblico/>}/>
          <Route path="/calendario-pubblico/:token" element={<CalendarioPubblico/>}/>
          <Route path="/allenatore"        element={<AllenatoreRoute><VocePortale><PortaleAllenatore/></VocePortale></AllenatoreRoute>}/>
          <Route path="/allenatore/contratti" element={<AllenatoreRoute><VocePortale><ContrattiAllenatore/></VocePortale></AllenatoreRoute>}/>
          <Route path="/allenatore/documenti" element={<AllenatoreRoute><VocePortale><DocumentiAllenatore/></VocePortale></AllenatoreRoute>}/>
          <Route path="/allenatore/anagrafica" element={<AllenatoreRoute><VocePortale><AnagraficaAllenatore/></VocePortale></AllenatoreRoute>}/>
          <Route path="/allenatore/rimborsi" element={<AllenatoreRoute><VocePortale><RimborsiAllenatore/></VocePortale></AllenatoreRoute>}/>
          <Route path="/allenatore/guida"  element={<AllenatoreRoute><VocePortale><GuidaAllenatore/></VocePortale></AllenatoreRoute>}/>
          <Route path="/calendario-allenatori" element={<AllenatoreRoute><VocePortale><CalendarioAllenatori/></VocePortale></AllenatoreRoute>}/>
          <Route path="/cliente"          element={<ClienteRoute><VocePortale><DashboardCliente/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/catalogo" element={<ClienteRoute><VocePortale><CatalogoSolaLettura/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/ordine"   element={<ClienteRoute><VocePortale><CatalogoCliente/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/ordini"   element={<ClienteRoute><VocePortale><OrdiniCliente/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/tickets"  element={<ClienteRoute><VocePortale><TicketsCliente/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/socio"    element={<ClienteRoute><VocePortale><RichiestaSocioPage/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/campi"    element={<ClienteRoute><VocePortale><CampiCliente/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/fipav/*"  element={<ClienteRoute><VocePortale><Fipav/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/aibvc"    element={<ClienteRoute><VocePortale><MioAibvc/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/tessera"  element={<ClienteRoute><VocePortale><LaMiaTessera/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/ricevute" element={<ClienteRoute><VocePortale><LeMieRicevute/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/profilo"  element={<ClienteRoute><VocePortale><IlMioProfilo/></VocePortale></ClienteRoute>}/>
          <Route path="/cliente/cambia-password" element={<ClienteRoute><CambiaPassword/></ClienteRoute>}/>
          <Route path="/cliente/guida"    element={<ClienteRoute><VocePortale><GuidaCliente/></VocePortale></ClienteRoute>}/>
          <Route path="/"                          element={<ProtectedRoute><Dashboard/></ProtectedRoute>}/>
          <Route path="/products/catalog"          element={<ProtectedRoute><ProductsCatalog/></ProtectedRoute>}/>
          <Route path="/products/categories"       element={<ProtectedRoute><Categories/></ProtectedRoute>}/>
          <Route path="/products/variants"         element={<ProtectedRoute><Variants/></ProtectedRoute>}/>
          <Route path="/products/warehouse"        element={<ProtectedRoute><Warehouse/></ProtectedRoute>}/>
          <Route path="/orders"                    element={<ProtectedRoute><Orders/></ProtectedRoute>}/>
          <Route path="/orders/new"                element={<ProtectedRoute><NewOrder/></ProtectedRoute>}/>
          <Route path="/customers"                 element={<ProtectedRoute><Customers/></ProtectedRoute>}/>
          <Route path="/customers/groups"          element={<ProtectedRoute><CustomerGroups/></ProtectedRoute>}/>
          <Route path="/suppliers"                 element={<ProtectedRoute><Suppliers/></ProtectedRoute>}/>
          <Route path="/suppliers/purchase-orders" element={<ProtectedRoute><PurchaseOrders/></ProtectedRoute>}/>
          <Route path="/dipendenti"                element={<ProtectedRoute><Dipendenti/></ProtectedRoute>}/>
          <Route path="/dipendenti/calendario"     element={<ProtectedRoute><CalendarioPresenze/></ProtectedRoute>}/>
          <Route path="/dipendenti/riepilogo"      element={<ProtectedRoute><RiepilogoMensile/></ProtectedRoute>}/>
          <Route path="/dipendenti/paghe"          element={<ProtectedRoute><PagheMensili/></ProtectedRoute>}/>
          <Route path="/dipendenti/listino"        element={<ProtectedRoute><ListinoAttivita/></ProtectedRoute>}/>
          <Route path="/dipendenti/template"       element={<ProtectedRoute><GestioneTemplate/></ProtectedRoute>}/>
          <Route path="/dipendenti/contratti"      element={<ProtectedRoute><ContrattiDipendenti/></ProtectedRoute>}/>
          <Route path="/dipendenti/:id"            element={<ProtectedRoute><SchedaDipendente/></ProtectedRoute>}/>
          <Route path="/cash/banca"                element={<ProtectedRoute><MovimentiBancari/></ProtectedRoute>}/>
          <Route path="/cash/centri"               element={<ProtectedRoute><Centri/></ProtectedRoute>}/>
          <Route path="/cash/resoconto"            element={<ProtectedRoute><ResocontoSpese/></ProtectedRoute>}/>
          <Route path="/cash/spese-ricorrenti"     element={<ProtectedRoute><SpeseRicorrenti/></ProtectedRoute>}/>
          <Route path="/settings"                  element={<ProtectedRoute><Settings/></ProtectedRoute>}/>
          <Route path="/settings/widgets"          element={<ProtectedRoute><Widgets/></ProtectedRoute>}/>
          <Route path="/changelog"                 element={<ProtectedRoute><Changelog/></ProtectedRoute>}/>
          <Route path="/segreteria"               element={<ProtectedRoute><Segreteria/></ProtectedRoute>}/>
          <Route path="/tesseramenti"             element={<ProtectedRoute><Tesseramenti/></ProtectedRoute>}/>
          <Route path="/business-plan"            element={<ProtectedRoute><SoloConPermesso modulo="business_plan"><BusinessPlan/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/organizzazione"           element={<ProtectedRoute><SoloConPermesso modulo="organizzazione"><Organizzazione/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/anagrafica"               element={<ProtectedRoute><SoloConPermesso modulo="anagrafica"><Anagrafica/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/form"                     element={<ProtectedRoute><SoloConPermesso modulo="form"><FormLista/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/form/:id"                 element={<ProtectedRoute><SoloConPermesso modulo="form"><FormEditor/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/tornei-fipav/*"           element={<ProtectedRoute><Fipav/></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/fipav/*" element={<ProtectedRoute><Fipav/></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/aibvc"   element={<ProtectedRoute><VocePortale><MioAibvc/></VocePortale></ProtectedRoute>}/>
          <Route path="/aibvc/*"                 element={<ProtectedRoute><Aibvc/></ProtectedRoute>}/>
          <Route path="/supporto"                 element={<ProtectedRoute><SoloConPermesso modulo="ticket"><SupportoStaff/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/calendario"               element={<ProtectedRoute><SoloConPermesso modulo="calendario"><CalendarioAttivita/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/ricevute-asd/*"          element={<ProtectedRoute><SoloConPermesso modulo="ricevute_asd"><RicevuteAsd/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/contabilita-tornei"       element={<ProtectedRoute><SoloConPermesso modulo="tornei"><ContabilitaTornei/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/strutture"                element={<ProtectedRoute><SoloConPermesso modulo="strutture"><ContrattiStrutture/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/planning"                 element={<ProtectedRoute><PlanningCorsi/></ProtectedRoute>}/>
          <Route path="/corsisti"                 element={<ProtectedRoute><Corsisti/></ProtectedRoute>}/>
          <Route path="/contabilita-corsi"        element={<ProtectedRoute><SoloConPermesso modulo="contabilita_corsi"><Corsisti contabilita/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/campi"                    element={<ProtectedRoute><Campi/></ProtectedRoute>}/>
          <Route path="/guida"                    element={<ProtectedRoute><SoloConPermesso modulo="guida"><Guida/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/guida/allenatori"         element={<ProtectedRoute><SoloConPermesso modulo="guida"><GuidaAllenatore/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/guida/utenti"             element={<ProtectedRoute><SoloConPermesso modulo="guida"><GuidaCliente/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/guida"    element={<ProtectedRoute><VocePortale><GuidaAllenatore/></VocePortale></ProtectedRoute>}/>
          <Route path="/password-manager"         element={<ProtectedRoute><SoloConPermesso modulo="password_manager"><PasswordManager/></SoloConPermesso></ProtectedRoute>}/>
          <Route path="/cambia-password"          element={<ProtectedRoute><CambiaPassword/></ProtectedRoute>}/>
          <Route path="/dipendenti/rimborsi"      element={<ProtectedRoute><Rimborsi/></ProtectedRoute>}/>
          <Route path="/le-mie-presenze"          element={<ProtectedRoute><VocePortale><PortaleAllenatore/></VocePortale></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/contratti"  element={<ProtectedRoute><VocePortale><ContrattiAllenatore/></VocePortale></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/documenti"  element={<ProtectedRoute><VocePortale><DocumentiAllenatore/></VocePortale></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/anagrafica" element={<ProtectedRoute><VocePortale><AnagraficaAllenatore/></VocePortale></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/tessera"    element={<ProtectedRoute><VocePortale><LaMiaTessera/></VocePortale></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/allenatori" element={<ProtectedRoute><VocePortale><CalendarioAllenatori/></VocePortale></ProtectedRoute>}/>
          <Route path="/le-mie-presenze/rimborsi"   element={<ProtectedRoute><VocePortale><RimborsiAllenatore/></VocePortale></ProtectedRoute>}/>
        </Routes>
      </BrowserRouter>
    </SidebarProvider>
    </ThemeProvider>
  );
};

// Pagina raggiungibile solo con il permesso view del modulo (ROOT sempre): oltre a nascondere la
// voce in sidebar, blocca anche chi digita l'indirizzo a mano. Il server blocca comunque i dati.
const SoloConPermesso = ({ modulo, children }) => {
  const { user } = useAuth();
  return puoFare(user, modulo, 'view') ? children : <Navigate to="/"/>;
};

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login"/>;
  if (user.ruolo === 'UTENTE')     return <Navigate to="/cliente"/>;
  if (user.ruolo === 'ALLENATORE') return <Navigate to="/allenatore"/>;
  if (user.primo_accesso) return <CambiaPasswordObbligatoria/>;
  if (user.informativa_collab_richiesta) return <InformativaCollaboratori/>;
  if (user.privacy_da_rivedere) return <AggiornamentoPrivacy/>;
  return <Layout>{children}</Layout>;
};

const ClienteRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login"/>;
  if (!['UTENTE','ALLENATORE'].includes(user.ruolo)) return <Navigate to="/"/>;
  if (user.primo_accesso) return <CambiaPasswordObbligatoria/>;
  if (user.informativa_collab_richiesta) return <InformativaCollaboratori/>;
  if (user.privacy_da_rivedere) return <AggiornamentoPrivacy/>;
  // L'allenatore = utente normale + presenze: stessa sidebar ovunque, così non "perde" le sue voci
  if (user.ruolo === 'ALLENATORE') return <LayoutAllenatore>{children}</LayoutAllenatore>;
  return <LayoutCliente>{children}</LayoutCliente>;
};

const AllenatoreRoute = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login"/>;
  if (user.ruolo !== 'ALLENATORE') return <Navigate to="/"/>;
  if (user.primo_accesso) return <CambiaPasswordObbligatoria/>;
  if (user.informativa_collab_richiesta) return <InformativaCollaboratori/>;
  if (user.privacy_da_rivedere) return <AggiornamentoPrivacy/>;
  return <LayoutAllenatore>{children}</LayoutAllenatore>;
};

export default function App() {
  return (
    <AuthProvider>
      <AppWithTheme/>
    </AuthProvider>
  );
}
